module.exports = __webpack_public_path__ + "static/media/facebook-icon.1340755d.svg";